module.exports = __webpack_public_path__ + "static/media/cover-image-libratone.5be19a63.jpg";